import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface CustomTabsProps {
  children: ReactNode;
}

const TabsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(0.5),
  borderBottom: '1px solid #CDD6D9',
}));

const CustomTabs: React.FC<CustomTabsProps> = ({ children }) => {
  return (
    <TabsContainer role="tablist" data-testid="custom-tabs-container">
      {children}
    </TabsContainer>
  );
};

export default CustomTabs; 